import PropTypes from 'prop-types'

const propTypes = {
  diff      : PropTypes.object,
  attribute : PropTypes.string
}

const ProductHistoryDiffView = ({ diff, attribute }) => {

  let from                = '-'
  let to                  = '-'
  const isDiffValuesArray = Array.isArray(diff[ attribute ])
  if (isDiffValuesArray) {
    from = String(diff[ attribute ][ 0 ])
    to   = String(diff[ attribute ][ 1 ])
  }

  return (
    <div className='d-flex'>
      <div className='font-weight-bold mr-3'>{ attribute }:</div>
      {
        isDiffValuesArray && (
          <div>
            { from }
            <span>{ ' => ' }</span>
            { to }
          </div>
        )
      }
      {
        !isDiffValuesArray && (
          diff[ attribute ] || '-'
        )
      }

    </div>
  )
}
ProductHistoryDiffView.propTypes = propTypes
export default ProductHistoryDiffView
